import { Stack, Typography } from '@mui/material';
import { AccessConditionEffect, type Role } from '@repo/api-gw-sdk';

import { RestoreAccountIndicator } from '@/components/accounts/restore/restoreAccountIndicator';

export const RestoreAccountLimitsSummary = ({ role }: { role: Role }) => {
  const condition = role.restoreDestinationLimits;
  if (!condition) {
    return null;
  }

  const isInclusive =
    condition.effect === AccessConditionEffect.RULE_EFFECT_INCLUSIVE;
  const ids = condition.restoreAccountProviderIds || [];

  return (
    <Stack direction='row' gap='8px' alignItems='center' flexWrap='wrap'>
      <Typography
        variant='body2'
        color={
          isInclusive
            ? 'var(--mui-palette-success-main)'
            : 'var(--mui-palette-error-main)'
        }
        sx={{ fontWeight: 500 }}
      >
        {isInclusive ? 'Allow' : 'Block'}
      </Typography>
      <Typography variant='body2'>restore to accounts:</Typography>
      {ids.slice(0, 3).map((id) => (
        <RestoreAccountIndicator
          key={id}
          providerAccountId={id}
          showAccountName={false}
          copyable={false}
        />
      ))}
      {ids.length > 3 && (
        <Typography variant='body2' color='text.secondary'>
          and {ids.length - 3} more
        </Typography>
      )}
      {ids.length === 0 && (
        <Typography variant='body2' color='text.secondary'>
          (no accounts selected)
        </Typography>
      )}
    </Stack>
  );
};

export const RestoreAccountLimitsTooltipSummary = ({
  role,
}: {
  role: Role;
}) => {
  const condition = role.restoreDestinationLimits;
  if (!condition) {
    return null;
  }

  const isInclusive =
    condition.effect === AccessConditionEffect.RULE_EFFECT_INCLUSIVE;
  const ids = condition.restoreAccountProviderIds || [];
  const displayIds = ids.slice(0, 3).join(', ');
  const suffix = ids.length > 3 ? ' and many more' : '';

  return (
    <Typography variant='body2'>
      <b>{isInclusive ? 'Allow' : 'Block'}</b> restore to accounts:{' '}
      {ids.length > 0 ? `${displayIds}${suffix}` : '(no accounts selected)'}
    </Typography>
  );
};
